import React from "react";
import UserStoresComp from "../../components/User/UserStores";

export default function UserStores() {
  return <UserStoresComp />;
}
